import VueSocketIO from 'vue-socket.io'
import SocketIO from 'socket.io-client'
import Vue from "vue";
import Config from '../config';
import Store from "../store";

if(Store.state.token){
    Vue.use(new VueSocketIO({
        connection: SocketIO(Config.socket, {
            transports: ['websocket'],
            query: {
                authorization: Store.state.token,
            }
        }),
    }));
}